import { getReqAuth, postReqAuth } from '../../api';

export const getAllCoursesAdmin = (cb) => getReqAuth('/webapi/institute/course/get/all', {}, '', cb);

export const getFilteredCoursesAdmin = (data, cb) =>
  postReqAuth('/webapi/institute/course/get/all-filtered', data, '', cb);

export const getAllCoursesOfOneStudent = (userId, cb) =>
  getReqAuth('/webapi/institute/course/get/all-course-of-student/', {}, userId, cb);

export const getSingleCoursesAdmin = (courseId, cb) =>
  getReqAuth('/webapi/institute/course/get/single/', {}, courseId, cb);

export const createCourse = (data, cb) => postReqAuth('/webapi/institute/course/create', data, '', cb);

export const createNewCourseEnrollmentAdmin = (data, cb) =>
  postReqAuth('/webapi/institute/course/create/enrollment/', data, '', cb);

export const verifyEnrollmentAdmin = (data, cb) =>
  postReqAuth('/webapi/institute/course/verify/enrollment', data, '', cb);

export const getEnrolledUsersInCourse = (
  courseId,
  text,
  limit,
  page,
  branchId,
  batchId,
  session,
  enrollmentType,
  institutionId,
  cb
) => {
  postReqAuth(
    '/webapi/institute/course/get/enrollments',
    {
      courseId,
      text,
      limit,
      page,
      branchId,
      batchId,
      session,
      enrollmentType,
      institutionId
    },
    '',
    cb
  );
};

export const updateCoursePageContent = (data, cb) =>
  postReqAuth('/webapi/institute/course/update-page-content', data, '', cb);

export const uploadCourseCoverPhoto = (file, cb) => {
  const token = localStorage.getItem('jwtToken');
  if (!token) return cb('Not authenticated', null);

  const formData = new FormData();
  formData.append('file', file);

  import('axios').then(({ default: axios }) => {
    import('../../../util/config').then(({ default: config }) => {
      axios.post(config.BASE_API_URL + '/webapi/institute/course/upload-cover-photo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: token,
        },
      })
        .then((res) => cb(null, res.data))
        .catch((err) => cb(err?.response?.data?.msg || 'Upload failed', null));
    });
  });
};
